/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { List } from 'immutable'
import MonthlyReportEvent from '../../event/MonthlyReportEvent'
import { DailyClosingHeadState } from '../state/DailyClosingHeadState'

class DailyClosingHeadsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case MonthlyReportEvent.monthlySalesMonthChanged:
        if (!payload) {
          return state
        }
        return List(payload.map(head => new DailyClosingHeadState(head)))

      default:
        return state
    }
  }
}

export default new DailyClosingHeadsStore()
